export default __webpack_public_path__ + "static/media/SkybagsMarvel1.03049ab8.jpg";